import React, { useState } from 'react';

interface Screenshot {
  id: number;
  title: string;
  description: string;
  image: string;
}

const screenshots: Screenshot[] = [
  {
    id: 1,
    title: "Trang chủ cộng đồng",
    description: "Khám phá tin tức và hoạt động trong khu phố",
    image: "/images/screenshots/01.png"
  },
  {
    id: 2,
    title: "Kết nối hàng xóm",
    description: "Gặp gỡ và làm quen với những người xung quanh",
    image: "/images/screenshots/02.png"
  },
  {
    id: 3,
    title: "Chợ trời địa phương",
    description: "Mua bán đồ cũ và thực phẩm tươi ngon",
    image: "/images/screenshots/03.png"
  },
  {
    id: 4,
    title: "Sự kiện cộng đồng",
    description: "Tham gia các hoạt động thú vị trong khu vực",
    image: "/images/screenshots/04.png"
  },
  {
    id: 5,
    title: "Nhóm quan tâm",
    description: "Tìm những người có cùng sở thích",
    image: "/images/screenshots/05.png"
  },
  {
    id: 6,
    title: "Tin nhắn và chat",
    description: "Trò chuyện trực tiếp với hàng xóm",
    image: "/images/screenshots/06.png"
  },
  {
    id: 7,
    title: "Hồ sơ cá nhân",
    description: "Quản lý thông tin và kết nối của bạn",
    image: "/images/screenshots/07.png"
  }
];

const ScreenshotsGallery: React.FC = () => {
  const [currentScreenshot, setCurrentScreenshot] = useState(0);

  const setScreenshotIndex = (index: number) => {
    setCurrentScreenshot(index);
  };

  return (
    <section className="mb-6 md:mb-8">
      <h2 className="text-xl md:text-2xl font-bold text-black mb-4 md:mb-6 px-2">Screenshots</h2>
      
      <div className="relative px-2">
        <div className="flex gap-3 md:gap-4 overflow-x-auto scrollbar-hide pb-2">
          {screenshots.map((screenshot) => (
            <div key={screenshot.id} className="flex-shrink-0 w-48 md:w-64">
              <div className="relative rounded-2xl md:rounded-3xl overflow-hidden shadow-lg bg-white aspect-[1/2]">
                {/* Screenshot Image */}
                <img
                  src={screenshot.image}
                  alt={screenshot.title}
                  className="w-full h-full object-cover"
                />
                
                {/* Glassmorphism overlay with title and description */}
                <div className="absolute bottom-0 left-0 right-0 p-4">
                  <div className="backdrop-blur-md bg-white/20 border border-white/30 rounded-2xl p-4 shadow-lg">
                    <h3 className="text-white text-sm md:text-base font-semibold mb-1 leading-tight drop-shadow-lg">
                      {screenshot.title}
                    </h3>
                    <p className="text-white/95 text-xs md:text-sm leading-tight drop-shadow-md">
                      {screenshot.description}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      
      {/* Screenshot Indicators - Hidden on mobile, shown on desktop */}
      <div className="hidden md:flex justify-center gap-2 mt-4">
        {screenshots.map((_, index) => (
          <button
            key={index}
            onClick={() => setScreenshotIndex(index)}
            className={`w-2 h-2 rounded-full transition-colors ${
              index === currentScreenshot ? 'bg-[#007AFF]' : 'bg-gray-300'
            }`}
          />
        ))}
      </div>
    </section>
  );
};

export default ScreenshotsGallery;
